import { SelectOption } from 'common/components/base/select/Select';

export const CATEGORY_DESCRIPTION_MAX_LENGTH = 1000;

export const NAME_MAX_LENGTH = 75;
export const DESCRIPTION_MAX_LENGTH = 200;
export const CATEGORY_NAME_MAX_LENGTH = 200;
export const CATEGORY_ORDER_MAX_LENGTH = 100;

export const SUB_CATEGORY_DESCRIPTION_MAX_LENGTH = 1000;
export const SUB_CATEGORY_NAME_MAX_LENGTH = 200;

export const SUB_CATEGORY_ORDER_MAX_LENGTH = 1000;
export const INDICATOR_DESCRIPTION_MAX_LENGTH = 1000;
export const INDICATOR_NAME_MAX_LENGTH = 200;
export const INDICATOR_SOURCE_MAX_LENGTH = 75;
export const INDICATOR_REFERENCE_MAX_LENGTH = 2500;

export const INDICATOR_ORDER_MAX_LENGTH = 10000;
export const INDICATOR_COUNTRY_VALUE_TYPE_DECIMAL_MAX_LENGTH = 100000000;
export const INDICATOR_COUNTRY_VALUE_TYPE_TEXT_MAX_LENGTH = 2500;

export const INDICATOR_YEAR_LIST = [
    { label: '2023', value: '2023' },
    { label: '2024', value: '2024' }
];

export const INDICATOR_TYPE_OPTIONS: SelectOption[] = [
    {
        label: 'Decimal',
        value: 'Decimal'
    },
    {
        label: 'Text',
        value: 'Text'
    },
    {
        label: 'Integer',
        value: 'Integer'
    }
];

export const INDICATOR_TAB_VALUES = ['Details', 'Countries list'];

export const INDICATOR_COUNTRY_LIST = [
    { label: 'Afghanistan', value: '0.03' },
    { label: 'Aland Island', value: '0.04' },
    { label: 'Albania', value: '0.05' },
    { label: 'Algeria', value: '0.03' },
    { label: 'American Samoa', value: '0.04' },
    { label: 'Andorra', value: '0.05' },
    { label: 'Angola', value: '0.03' },
    { label: 'Anguilla', value: '0.04' },
    { label: 'Argentina', value: '0.05' },
    { label: 'Australia', value: '0.05' },
    { label: 'Iceland', value: '0.04' },
    { label: 'Scotland', value: '0.03' }
];

export const INDICATOR_ORDER_OPTIONS: SelectOption[] = [
    {
        label: '1',
        value: '1'
    },
    {
        label: '2',
        value: '2'
    },
    {
        label: '3',
        value: '3'
    }
];

export const INDICATOR_SORT_ORDER: SelectOption[] = [
    {
        label: 'Ascending',
        value: 'Ascending'
    },
    {
        label: 'Descending',
        value: 'Descending'
    }
];

export const INDICATOR_UPDATE_FREQUENCY: SelectOption[] = [
    {
        label: 'Annually',
        value: '1e001a8f-ea9a-43b3-a3cf-0e2e4468c747'
    },
    {
        label: 'Quarterly',
        value: 'e575c582-8036-4e05-aac2-38265ea36322'
    },
    {
        label: 'Monthly',
        value: '10e55757-bc68-401e-9f5c-6a1944e64ced'
    },
    {
        label: 'Weekly',
        value: '10709345-b852-4351-8558-ce72e611a996'
    },
    {
        label: 'Daily',
        value: '97760bea-e6f0-4866-9d40-87e49f3fe6af'
    }
];
